package com.sddamico.swigmore.ds.poll

/** Week-over-week rank change, rendered as ▲2 / ▼1 / — / NEW. */
sealed interface Movement {
  val label: String

  data class Up(val by: Int) : Movement { override val label get() = "▲$by" }
  data class Down(val by: Int) : Movement { override val label get() = "▼$by" }
  data object Same : Movement { override val label = "—" }
  data object New : Movement { override val label = "NEW" }

  companion object {
    /** [lastWeek] is last week's rank, or null if the team was unranked. */
    fun of(rank: Int, lastWeek: Int?): Movement = when {
      lastWeek == null -> New
      lastWeek == rank -> Same
      lastWeek > rank -> Up(lastWeek - rank)
      else -> Down(rank - lastWeek)
    }
  }
}
